import React, { useEffect, useState } from 'react'
import { GridColumn, GridRow, Icon, Button } from 'semantic-ui-react'
import StateSelectFormField from '../../form/common/inputs/StateSelectFormField'
import ControlledFormField from '../../common/ControlledFormField'
import { GROUP_TYPES } from '../../../constant/GROUP_TYPES'
import { PRODUCT_PRETTY_NAME_MAP } from '../../../constant/PRODUCTS'
import getProductInformationByState from '../../../api/getProductInformationByState'
import toStateSpecialAbbreviation from '../../../util/toStateSpecialAbbreviation'
import Loader from '../../common/Loader'
import useLoading from '../../../hooks/useLoading'
import Message from '../../common/Message'
import axios from "../../../api/config/axios";

export default function PDFDownloadByState ({ state = {}, setState, additionalQueryParams = null }) {
  const [products, setProducts] = useState({})
  const { isLoading, loading, done } = useLoading()

  const buildQueryParams = (fileName) => {
    return [
      `filename=${fileName}`,
      additionalQueryParams
    ].filter(Boolean).join('&')
  }

  const downloadFile = async (url, fileName) => {
    try {
      const response = await axios.get(url, { responseType: 'blob' })
      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(link.href)
    } catch (err) {
      console.error('Error downloading file:', err)
    }
  }

  const AxiosButton = ({ url, fileName, children }) => {
    const handleClick = (e) => {
      e.preventDefault()
      downloadFile(url, fileName)
    }

    return (
        <Button
            data-testid="axios-button"
            onClick={handleClick} className='Button Button--flat custom-link-btn form-download-link'>
          {children}
        </Button>
    )
  }


  useEffect(() => {
    if (state.groupType.value && state.usState.value && state.groupNumber.value) {
      loading()
      getProductInformationByState(toStateSpecialAbbreviation(state.usState.value, state.groupType.value), state.groupNumber.value)
        .then(r => {
          done()
          setProducts(r)
          setState({ key: 'error', value: undefined })
        })
        .catch(() => {
          done()
          setState({ key: 'error', value: 'Error fetching forms. Please try again later.' })
        })
    } else {
      setState({ key: 'error', value: undefined })
      setProducts({})
    }
    // eslint-disable-next-line
  }, [state.groupType.value, state.usState.value])

  return <GridRow className={isLoading ? 'Dimmed' : ''}>
    {isLoading && <Loader />}
    <GridColumn width={10}>
      <StateSelectFormField
        id='homeState'
        label='State of Residence'
        value={state.usState.value}
        onChange={(e) => setState({ key: 'usState.value', value: e.target.value })}
        disabled={!state.groupNumber.value}
      />
    </GridColumn>
    {state.usState.value === 'TX' && <GridColumn className='u-mY0' width={10}>
      <ControlledFormField
        id='groupType'
        inputType='select'
        label='Group Type'
        options={GROUP_TYPES}
        placeholder='Select Group Type'
        value={state.groupType.value}
        onChange={(e) => setState({ key: 'groupType.value', value: e.target.value })}
      />
    </GridColumn>}
    {!state.error && <GridColumn width={16} textAlign='center'>
      {Object.keys(products).filter(product => products[product]).map(p => {
        return <AxiosButton
            data-testid="axios-button"
            key={p}
            fileName={`${PRODUCT_PRETTY_NAME_MAP[p]}.pdf`}
            url={`/api/forms/blank-filename?${buildQueryParams(products[p])}`}
        >
          {PRODUCT_PRETTY_NAME_MAP[p]}&nbsp;&nbsp;<Icon name='download' />
        </AxiosButton>
      })}
    </GridColumn>}
    {state.error && <GridColumn computer={12} tablet={16} mobile={16}>
      <Message content={state.error} type='critical' />
    </GridColumn>}
  </GridRow>
}